<template>
    <div id="modal-buy" class="modal modal-buy">
        <div class="modal-body">
            <div class="modal-content">
                <a href="#" class="modal-close-btn" aria-label="Закрыть">
                    <svg width="18" height="18">
                        <use xlink:href="#icon-del"/>
                    </svg>
                </a>
                <div class="modal-title">Купить {{ composition }}&#160{{ title }}</div>
                <div class="modal-product">
                    <div class="modal-product-img" v-if="picture">
                        <img :src="picture" :srcset="`${picture} 1x,${picture}`" alt="">
                    </div>
                    <div class="modal-product-body">
                        <div class="modal-product-title">
                            <!--    {{ composition }}{{ size ? ',' : '' }} {{ size }}{{ country ? ',' : '' }} -->
                            <span v-if="country" class="catalog-item-country">
                                <span>{{ country }}</span>
                                <i><img :src="countryFlag" alt=""></i>
                            </span>
                        </div>
                        <div class="modal-product-desc" v-html="description"></div>
                    </div>
                </div>
                <div class="modal-form-number">
                    <div class="product-form-number-desc" v-if="meterQuantity > 0">
                        <p>1 уп. = {{ meterQuantity }} м&sup2; = {{ boxQuantity }} шт</p>
                        <p>Данный товар отпускается кратно упаковкам.</p>
                    </div>
                    <div class="modal-form-number-total">Итого: <b>{{ formattedPrice }}</b> руб</div>
                    <div class="select-number">
                        <div class="select-number-body">
                            <button type="button" class="select-number-btn select-number-btn-minus"
                                    :class="{disabled: quantity === minimumQuantity}" @click="quantity -= quantityStep">
                                <svg width="10" height="10">
                                    <use xlink:href="#icon-minus"/>
                                </svg>
                            </button>
                            <input type="text" class="select-number-input" :data-min="meterQuantity"
                                   :value="formattedQuantity" :data-step="meterQuantity"
                                   v-on:focus="onFocusHandler" v-on:change="onChangeHandler" v-on:blur="onBlurHandler"
                            ><!--:data-max="meterQuantity * maximumQuantity"-->
                            <button type="button" class="select-number-btn select-number-btn-plus"
                                    :class="{disabled: quantity === maximumQuantity}" @click="quantity += quantityStep">
                                <svg width="10" height="10">
                                    <use xlink:href="#icon-plus"/>
                                </svg>
                            </button>
                        </div>

                        <ul class="select-number-unit-switcher" v-if="meterQuantity > 0">
                            <li class="active">
                                <a href="#" :data-min="meterQuantity" :data-max="meterQuantity * maximumQuantity"
                                   :data-value="meterQuantity * quantity" :data-step="meterQuantity"
                                   @click="mode = 'meter'">
                                    м&sup2;
                                </a>
                            </li>
                            <li>
                                <a href="#" :data-min="minimumQuantity" :data-max="maximumQuantity"
                                   :data-value="quantity"
                                   :data-step="quantityStep" data-unit=" уп."
                                   @click="mode = 'box'">
                                    уп.
                                </a>
                            </li>
                        </ul>

                    </div>
                    <a href="#" class="product-form-delivery-switcher active">Нужна доставка</a>
                </div>
                <div class="modal-buy-submit">
                    <a href="#" class="modal-buy-btn btn btn-large" @click.prevent="buyRedirect()">
                        <span>
                            <b>Купить</b>
                            <span>и перейти к оформлению заказа</span>
                        </span>
                    </a>
                    <a href="#" class="modal-close-link" @click.prevent="buy()">
                        Добавить в корзину и продолжить покупки
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<!--suppress JSUnfilteredForInLoop, JSUnresolvedFunction, JSUnresolvedVariable -->
<script>
export default {
    name: "ModalElementBuy",
    data() {
        return {
            productId: 0,

            title: '',
            picture: '',
            composition: '',
            size: '',
            country: '',
            countryFlag: '',
            description: '',

            meterQuantity: 0,
            boxQuantity: 0,
            basePrice: 0,
            minimumQuantity: 1,
            maximumQuantity: Infinity,
            currentQuantity: 1,
            quantityStep: 1,

            quantity: 1,
            mode: 'meter', // ['meter', 'box']
            pieceGood: false
        }
    },
    mounted() {
        /** Open this modal */
        VueEventBus.$on('element|open-modal-buy', (config) => this.init(config));
        VueEventBus.$on('element|buy', (config) => {
            this.init(config, false);
            this.buy();
        });

        $(document).on('click', '.category-item-btn', (e) => {
            e.preventDefault();

            let config = $(e.target).closest('.category-item-form').data('config');

            if (config) {
                this.init(config);
            }
        });
    },
    computed: {
        formattedPrice() {
            return Intl.NumberFormat('ru-RU').format(this.price);
        },
        measure() {
            if (this.pieceGood) {
                return ' шт.';
            } else {
                return ' м²';
            }
        },
        price() {
            let price;
            if (this.meterQuantity) {
                price = this.basePrice * this.quantity * this.meterQuantity;
            } else {
                price = this.basePrice * this.quantity;
            }

            if (this.mode === 'box') {
                price *= this.boxQuantity;
            }

            return price;
        },
        formattedQuantity() {
            if (this.mode === 'meter') {
                if (this.meterQuantity === 0) {
                    return `${this.quantity}${this.measure}`;
                } else {
                    return `${(this.meterQuantity * this.quantity).toFixed(2)}` + this.measure;
                }
            } else {
                return `${this.quantity} уп.`;
            }
        }
    },
    watch: {
        quantity(quantity) {
            if (quantity < this.minimumQuantity || isNaN(quantity)) {
                this.quantity = this.minimumQuantity;
            }

            if (quantity > this.maximumQuantity) {
                this.quantity = this.maximumQuantity;
            }
        },
    },
    methods: {
        init(config, showModal = true) {
            const defaultValues = {
                title: '',
                picture: '',
                composition: '',
                size: '',
                country: '',
                countryFlag: '',
                description: '',

                meterQuantity: 0,
                boxQuantity: 0,
                basePrice: 0,
                minimumQuantity: 1,
                maximumQuantity: Infinity,
                currentQuantity: 1,
                quantityStep: 1,

                quantity: 1,
                mode: 'meter', // ['meter', 'box']
                pieceGood: false
            };

            for (let key in defaultValues) {
                if (this.hasOwnProperty(key)) {
                    this[key] = defaultValues[key];
                }
            }

            for (let key in config) {
                if (this.hasOwnProperty(key)) {
                    this[key] = config[key];
                }
            }

            if (showModal) {
                openModal('#modal-buy');
            }
        },
        buyRedirect() {
            this.buy(() => {
                location.href = '/order/';
            });
        },
        buy(callback) {
            if (this.productId <= 0) {
                console.error('Element not found!');
                return;
            }

            let formData = new FormData(),
                params = {
                    sessid: BX.bitrix_sessid(),
                    action: 'addToBasket',
                    id: this.productId,
                    quantity: this.quantity,

                    price: Math.round(this.basePrice * this.boxQuantity),

                    meterQuantity: this.meterQuantity,
                    boxQuantity: this.boxQuantity,
                };


            for (let key in params) {
                formData.append(key, params[key]);
            }

            closeModal();
            axios.post('/ajax/', formData).then(response => {

                if (response.data.success) {
                    $('.head-cart-count').text(response.data.basket.quantity);
                    $('.head-cart-sum').text(response.data.basket.summaryFormatted);

                    openModal('#modal-cart-add');
                } else {
                    let error = response.data.errors[0] ? response.data.errors[0].message : '';

                    error && console.error(error);
                }

                if (typeof callback === 'function') {
                    callback(response);
                }
            });
        },
        onFocusHandler(e) {
            e.target.value = this.quantity;
        },
        onBlurHandler(e) {
            e.target.value = this.formattedQuantity;
        },
        onChangeHandler(e) {
            this.quantity = parseInt(e.target.value);
        }
    }
}
</script>

<style scoped>

</style>